














































import {Component, Vue, Emit} from 'vue-property-decorator';
import {VSpacer, VToolbar, VToolbarItems, VToolbarSideIcon, VToolbarTitle} from 'vuetify/lib';

@Component({
	components: {
		VSpacer,
		VToolbar,
		VToolbarItems,
		VToolbarSideIcon,
		VToolbarTitle,
	},
})
export default class Header extends Vue {
	@Emit()
	// tslint:disable-next-line:no-empty
	private sideIconClick() {}
}
